import React, { useEffect, useState } from 'react';

import { Loader } from '@mantine/core';
import { Navigate } from 'react-router-dom';

import { checkIsAdmin } from './services/config'; // o donde tengas esa función

// Componente que protege las rutas de admin
export const AdminRoute: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState<boolean>(false);

  useEffect(() => {
    const run = async (): Promise<void> => {
      try {
        const admin = await checkIsAdmin();
        setIsAdmin(admin);
      } catch (error) {
        console.error('Error verificando admin:', error);
      } finally {
        setLoading(false);
      }
    };

    void run();
  }, []);

  if (loading) {
    return (
      <div style={{ textAlign: 'center', marginTop: '2rem' }}>
        <Loader />
      </div>
    );
  }

  if (!isAdmin) {
    // Si no es admin, redirigimos a la página principal
    return <Navigate to="/home" replace />;
  }

  // Si es admin, renderizamos los hijos (AdminLayout + sub-rutas)
  return children;
};
